<template>
    <div id="itb-language-menu" class="card itb-top-tail itb-adjust-menu-01">
        <button
            v-if="appParams && appParams.staticTranslations"
            class="itb-mdi-logo"
            @click="closeMenu"
        >
            <img
                src="/images/times-solid.svg"
                alt="close-button"
                class="itb-icon itb-paperplane"
            />
        </button>
        <div
            v-if="appParams && appParams.staticTranslations"
            class="itb-cart-hover-body"
        >
            <div
                class="itb-flag-icon-wrapper"
                v-for="(oLanguage, otherLanguageIndex) in otherLanguages"
            >
                <a :href="oLanguage.fullUrl" class="itb-language-link">
                    <label
                        :for="'itb-language-input-' + oLanguage.code"
                        class="itb-checkbox-label"
                        ><input
                            type="radio"
                            :id="'itb-language-input-' + oLanguage.code"
                            name="itb-language-selector"
                            :value="oLanguage.code"
                            :checked="oLanguage.isCurrentLanguage"
                            @change="redirectToUrl(oLanguage.fullUrl)"
                        />
                        <span class="itb-checkbox"></span>
                    </label>
                    <img
                        class="itb-flag-icon"
                        :src="
                            '/images/flag_icons/' +
                            oLanguage.country_flag.toLowerCase() +
                            '.svg'
                        "
                    />
                    <p class="p-0 m-0">{{ oLanguage.name }}</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Jwt from "jsonwebtoken";
import { mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";

export default {
    name: "LanguageMenu",
    props: {
        otherLanguages: Array,
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            appParams: "getAppParams",
        }),
    },

    methods: {
        closeMenu() {
            this.$emit("close");
        },

        redirectToUrl(url) {
            window.location.href = url;
        },
    },
};
</script>
